class DlFooterH extends HTMLElement {
    constructor() {
        super();
        this.downloadItems = this.querySelectorAll('.dl-footer-h-download-item');
        this.countrySelectors = this.querySelectorAll('.dl-footer-h-markets-select select');
        this.countryForm = this.querySelector('#localization_form');
    }

    connectedCallback() {
        this.downloadItems.forEach(item => {
            item.addEventListener('click', this.onDownloadItemClick.bind(this));
        });
        this.countrySelectors.forEach(e => e.addEventListener('change', this.onCountrySelectorChange.bind(this)))
    }

    onDownloadItemClick(event) {

        let clickedItem = event.currentTarget;
        if (clickedItem.classList.contains('dl-download-show')) {
            clickedItem.classList.remove('dl-download-show')
        }
        else {
            this.downloadItems.forEach(item => {
                item.classList.remove('dl-download-show')
            })
            clickedItem.classList.add('dl-download-show');
        }
    }

    onCountrySelectorChange(event) {
        var selectedOption = event.target.options[event.target.selectedIndex];
        var type = selectedOption.getAttribute('data-type');
        switch (type) {
            case 'link':
                location.href = selectedOption.value;
                break;
            case 'market':
                if (dLSetCookie) {
                    dLSetCookie('cozy_remove', 'Y', null, '.petlibro.com');
                    dLSetCookie('cozy_from', 'ca', null, '.petlibro.com');
                }
                this.querySelector('input[name="country_code"]').value = selectedOption.value;
                this.countryForm.submit();
                break;
        }
    }
}
customElements.define('dl-footer-h', DlFooterH);
class DLNewsletterH extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }
    onFormSubmit(event) {
        event.preventDefault();
        const form = event.target;
        try {
            const emailInput = form.querySelector('input[name="contact[email]"]');
            const email = emailInput?.value?.trim();
            if (!email) {
                console.warn('No email provided');
                return;
            }
            DLPixelH.identify(email);
        } catch (error) {
            console.error('Error identifying email:', error);
        }
    }
}
customElements.define('dl-newsletter-h', DLNewsletterH);